export const FETCH_PRODUCTS = {
  init: 'products/FETCH_PRODUCTS/init',
  request: 'products/FETCH_PRODUCTS/request',
  loading: 'products/FETCH_PRODUCTS/loading',
  success: 'products/FETCH_PRODUCTS/success',
  failure: 'products/FETCH_PRODUCTS/failure',
  cancel: 'products/FETCH_PRODUCTS/cancel',
} as const;

export const PRODUCTS_RESET = 'products/RESET' as const;

export const PRODUCTS_STORE_NAME = 'products' as const;
